export function createList(items: readonly string[]): HTMLUListElement {
  const list = document.createElement("ul");
  list.className = "hover-idle-help-list";
  for (const item of items) {
    const listItem = document.createElement("li");
    listItem.textContent = item;
    list.append(listItem);
  }
  return list;
}
